<template>
  <div class="row ccm00100-login">
    <div class="col sheet primary">
      <div class="col ccm00100-caption column justify-end text-white">
        <div class="vertical-logo-area logo">
          <img src="../assets/tate_panda_logo.svg" alt="" />
        </div>
        <p>◎ ChemPandaのご利用にあたり、費用のご負担は一切ありません。</p>
        <p>
          ◎
          ChemPandaには、全世界のサプライヤ約350社の製品データとして、試薬及びバルク製品（電子材料、農薬原料、化粧品原料、塗料・インキ・接着剤、天然物、機能性材料、医薬品中間体、原薬（API））が登録されており、幅広く自由に検索できます。
        </p>
        <p>
          ◎
          試薬（在庫品・カスタム合成品）は、グローバルなサプライヤの製品をニーズに応じて検索できます。
        </p>
        <p>◎ バルク製品は、中国の現地サプライヤ が展開する多様な製品を網羅しています。</p>
        <p>◎ 構造式検索のほか、キー検索、リスト検索が可能です。</p>
        <p>◎ 検索結果より御見積書の発行やご注文ができます。</p>
      </div>
    </div>
    <div class="col sheet">
      <div class="column justify-center items-center ccm00100-form-card">
        <MessageChip
          :display="isMessageChip"
          level="E"
          :message="!!$route.query.error ? $t('message.MSG_50001E') : $t('message.MSG_50002E')"
        />
        <q-card bordered flat class="bg-grey-2" style="width: 100%">
          <q-card-section class="column justify-center items-center q-gutter-y-md">
            <div class="customer-logo">
              <img src="../assets/atto_logo.svg" alt="" />
            </div>
            <q-form
              id="loginForm"
              ref="loginForm"
              action="/login"
              method="post"
              class="column justify-center items-center q-gutter-xs"
              style="width: 70%"
              novalidate
              autocomplete="off"
              greedy
              @validation-error="resetError"
            >
              <q-input id="_csrf" v-model="csrfToken" style="display: none" name="_csrf" />
              <div class="col" style="width: 100%">
                <label>会員ID（メールアドレス）</label>
                <q-input
                  id="mail_address"
                  v-model="mail_address"
                  outlined
                  name="mail_address"
                  dense
                  :rules="[(val: any) => !!val || $t('validation.required')]"
                  lazy-rules
                  type="email"
                  bg-color="white"
                  maxlength="254"
                  autofocus
                  class="input-area"
                />
              </div>
              <div class="col" style="width: 100%">
                <label>パスワード</label>
                <q-input
                  id="password"
                  v-model="password"
                  outlined
                  name="password"
                  dense
                  :rules="[(val: any) => !!val || $t('validation.required')]"
                  :type="isPwd ? 'password' : 'text'"
                  bg-color="white"
                  maxlength="72"
                  class="input-area left-input"
                >
                  <template #append>
                    <q-icon
                      :name="isPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isPwd = !isPwd"
                    />
                  </template>
                </q-input>
              </div>
              <q-btn
                label="ログイン"
                type="submit"
                style="width: 200px"
                color="primary"
                @click="Loading.show()"
              />
            </q-form>
            <div class="row">
              <router-link
                :to="{ name: 'passwordReissue', params: { isLogin: '0' } }"
                class="text-link"
              >
                ログインできない場合はこちら
              </router-link>
            </div>
            <q-separator class="ccm00100-separator" style="width: 100%" />
            <div class="row">
              <q-btn
                label="新規会員登録"
                outline
                color="primary"
                style="width: 200px; background: var(--q-white) !important"
                :to="{ name: 'memberRegist', params: { isLogin: '0' } }"
              />
            </div>
          </q-card-section>
        </q-card>
      </div>
      <NewsAreaScroll display-screen="0" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Loading } from 'quasar';
import { useRoute } from 'vue-router';
import MessageChip from '../components/chip/MessageChip.vue';
import NewsAreaScroll from '../components/scroll/NewsAreaScroll.vue';

const route = useRoute();
// cookie
const cookies = document.cookie;
// CSRFトークン
let cookiesArray = cookies.split(';');
cookiesArray = cookiesArray[0].split('=');
const csrfToken = cookiesArray[1];
// メールアドレス
const mail_address = ref('');
// パスワード
const password = ref('');
// パスワードマスキングフラグ
const isPwd = ref(true);
// MessageChip表示フラグ
const isMessageChip = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  Loading.hide();
  isMessageChip.value = false;
};

/**
 * 初期表示
 */
if (!!route.query.error || !!route.query.timeout) {
  isMessageChip.value = true;
}
</script>

<style scoped>
.ccm00100-caption p {
  line-height: 17px;
  text-indent: -1.4em;
  padding-left: 1em;
}

.ccm00100-login .sheet {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.ccm00100-login .sheet.primary {
  background: linear-gradient(to bottom, var(--q-gradientStart), var(--q-gradientEnd));
}
.ccm00100-caption {
  width: 85%;
  padding-bottom: 12%;
}
.ccm00100-login .customer-logo {
  width: 22%;
}
.ccm00100-login .logo {
  width: 90%;
  margin-bottom: 15px;
}
.ccm00100-form-card {
  width: 80%;
  margin-bottom: 0;
}

.ccm00100-caption .vertical-logo-area {
  width: 240px;
  margin: 0 auto 5%;

  display: flex;
  justify-content: center;
}

.ccm00100-caption .vertical-logo-area img {
  width: 620px;
  max-width: none;
  transform: translateX(-5px);
}
</style>
<style>
.ccm00100-form-card .message-chip {
  margin: 0;
}

.ccm00100-form-card .message-chip .q-chip {
  margin: 0 0 10px;
}
</style>
